/**
 * isiZulu: Knowledge base
 *
 * What this file covers: The knowledge base the chatbot answers from: documents, websites, corrections,
 * conflicts and trying a question.
 *
 * Tone: Plain and patient. Explain what the chatbot will and will not know.
 *
 * isiZulu: Everyday isiZulu as used in South African business. Keys not translated yet fall back to English, so
 * a missing key is never an error.
 *
 * Rules for every translation: keep each key exactly as it is and translate only the text after it. Keep
 * {{placeholders}} such as {{count}} or {{name}} unchanged, and keep product names (RepletoryReach, WhatsApp,
 * Meta, Google, Outlook) as they are. Never use the em dash.
 */

import type { Catalog } from '../types';

const knowledge: Catalog = {
  'knowledge.add.hintMany': 'I-PDF, umbhalo, Markdown, HTML noma CSV, kuze kufike ku-20 MB ngayinye. Khetha amaningi ngasikhathi sinye: ifayela ngalinye lifakwa emgqeni uma selilayishiwe, bese lihlelwa ngokulandelana, futhi ukuhlela kuyaqhubeka noma ushiya leli khasi.',
  'knowledge.add.queued': 'Kufakwe emgqeni ukuze kuhlelwe: {{count}}',
  'knowledge.add.refusedTitle': 'Amanye amafayela awengezwanga',
  'knowledge.add.refused.PLAN_LIMIT_REACHED': '{{name}}: isizinda solwazi sohlelo lwakho sigcwele. Susa idokhumenti noma shintsha uhlelo ukuze wengeze okwengeziwe.',
  'knowledge.add.refused.ALREADY_ADDED': '{{name}}: selikhona esizindeni sakho solwazi.',
  'knowledge.add.refused.NO_TEXT': '{{name}}: akukho mbhalo ofundekayo otholakele. I-PDF eskeniwe idinga ukuthi umbhalo wayo ubonakale kuqala.',
  'knowledge.add.refused.MEDIA_NOT_FOUND': '{{name}}: ukulayisha akutholakalanga. Liphinde ulilayishe.',
  'knowledge.add.refused.other': '{{name}}: {{message}}',
  'knowledge.add.sending': 'Kwengezwa amafayela alayishiwe…',
  'knowledge.list.status': 'Isimo',
  'knowledge.status.queued': 'Emgqeni',
  'knowledge.status.indexing': 'Kuyahlelwa',
  'knowledge.status.indexed': 'Kuhleliwe',
  'knowledge.status.failed': 'Kwehlulekile',
  'knowledge.list.retry': 'Zama i-{{name}} futhi',
  'knowledge.list.pending': 'Kuhlelwa amadokhumenti angu-{{count}}, elilodwa ngesikhathi. Ungashiya leli khasi.',
  'knowledge.toast.retried': '"{{name}}" libuyiselwe emgqeni',
  'knowledge.toast.retryFailed': 'Ayikwazanga ukubuyisela idokhumenti emgqeni',
  'knowledge.assistant.offerName': 'Nikeza umuntu weqembu',
  'knowledge.assistant.offer': 'Ungathanda ukuthi ngidlulisele lokhu komunye weqembu lethu?',
  'knowledge.assistant.offerYes': 'Yebo',
  'knowledge.assistant.offerNo': 'Cha',
  'knowledge.assistant.offerRetry': 'Sicela uphendule ngo-Yebo noma Cha.',
  'knowledge.assistant.declined': 'Akunankinga. Ngibuze noma yini enye noma nini.',
  'knowledge.assistant.intro': 'Abantu abalandeli uhlelo uma bekuthumelela umlayezo. Bayabuza. Vula lokhu futhi i-bot izophendula noma yimuphi umlayezo ongathathwa olunye uhlelo, isebenzisa yonke imibhalo ekhona lapha. Uma ingaqiniseki, iqala ngokubuza ukuthi bangathanda yini usizo lomuntu weqembu lakho, bese ibuza ukuthi badingani nokuthi bangafinyelelwa kanjani, bese yazisa ithimba lakho.'
};

export default knowledge;
